// https://uponly.larksuite.com/wiki/OjzgwKJwBisrTbkKHjCumpDvsMg
var isDEV = process.env.NODE_ENV === 'development';

// 转换为相对路径的映射
export var TransformPath = new Map([
// 前台bucket
['https://fh-static.bycsi.com', '/common-static/fhs'],
// 中台法币期货testnet bucket
['https://t1.bycsi.com', '/bycsi-root'],
// 中台法币期货mainnet bucket
['https://s1.bycsi.com', '/bycsi-root']]);

// 判断是否是支持的域名
// 如果是相对路径，会构建URL出错，返回false
export function isSupportedDomain(src) {
  try {
    var url = new URL(src);
    return TransformPath.has(url.origin);
  } catch (error) {
    return false;
  }
}

// 判断是否是moly站点
export function isMoly() {
  if (typeof window === 'undefined') return false;
  return window.origin.includes('moly.');
}

// 转换为相对路径
export function toRelativePath(url) {
  if (!isSupportedDomain(url)) return url;
  var res = url;
  TransformPath.forEach(function (relativePrefix, prefix) {
    if (url.startsWith(prefix)) {
      res = url.replace(prefix, relativePrefix);
      if (isDEV || isMoly()) {
        res = 'https://www.bybit.com' + res;
      }
    }
  });
  return res;
}